module.exports = __webpack_public_path__ + "officialStatic/img/chuangweiLogo.0738ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/chuangweiLogo.png
// module id = LKzU
// module chunks = 0